"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addLocale = void 0;

var _normalizeTrailingSlash = require("./normalize-trailing-slash");

var addLocale = function addLocale(path) {
  if (process.env.__NEXT_I18N_SUPPORT) {
    var _require;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return (0, _normalizeTrailingSlash).normalizePathTrailingSlash((_require = require('../shared/lib/router/utils/add-locale')).addLocale.apply(_require, [path].concat(args)));
  }

  return path;
};

exports.addLocale = addLocale;

if ((typeof exports["default"] === 'function' || typeof exports["default"] === 'object' && exports["default"] !== null) && typeof exports["default"].__esModule === 'undefined') {
  Object.defineProperty(exports["default"], '__esModule', {
    value: true
  });
  Object.assign(exports["default"], exports);
  module.exports = exports["default"];
}